import { useRef, useEffect, useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";

const DATA = [
  { name: "Ramisetti Venkateswara Rao", city: "Vijayawada", rating: 5, review: "Had laparoscopic cholecystectomy done by Dr. Dileep. Excellent surgery with minimal pain. Was back to normal in just one week. Highly recommend!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Duvvuri Satyavathi", city: "Vijayawada", rating: 5, review: "Dr. Dileep removed my gallbladder laparoscopically. The entire experience from consultation to surgery was smooth. Very kind and professional doctor.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Kotagiri Apparao", city: "Guntur", rating: 5, review: "I was suffering from gallstones for months. Dr. Dileep laparoscopic surgery was quick and painless. Discharged the same day!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Undavalli Suryanarayana", city: "Vijayawada", rating: 5, review: "My wife had gallbladder surgery with Dr. Dileep. He explained everything clearly and the surgery went perfectly. She recovered very quickly.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Mandava Venkataramana", city: "Tenali", rating: 5, review: "Best surgeon for gallbladder removal. No complications, minimal scars, and I was eating normally within 3 days. Thank you Dr. Dileep!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Gollapudi Hymavathi", city: "Vijayawada", rating: 5, review: "Dr. Dileep is an exceptional surgeon. My cholecystectomy was done with utmost precision. The staff at the hospital was also very supportive.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Jonnalagadda Krishnamurthy", city: "Machilipatnam", rating: 5, review: "Travelled from Machilipatnam for gallbladder surgery. Dr. Dileep expertise made me feel confident. Quick procedure and fast recovery.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Movva Sravanthi", city: "Vijayawada", rating: 5, review: "I had severe gallstone attacks. Dr. Dileep performed laparoscopic surgery and I was pain-free within days. Excellent doctor!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Chittibomma Ravindra", city: "Vijayawada", rating: 5, review: "Dr. Dileep laparoscopic cholecystectomy was a life-changer for me. No more stomach pain after eating. Smooth recovery and caring staff.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Nuthalapati Bharathamani", city: "Eluru", rating: 5, review: "Came from Eluru for gallbladder surgery. Dr. Dileep skill and the modern facilities made the entire experience comfortable. Highly satisfied!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Ponnada Nagaraju", city: "Vijayawada", rating: 5, review: "My mother had gallbladder surgery with Dr. Dileep. He was patient, explained the procedure in Telugu, and took excellent care. Grateful!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Alapati Vijayalakshmi", city: "Vijayawada", rating: 5, review: "Had my gallbladder removed by Dr. Dileep. Keyhole surgery with tiny scars. Back at work in a week. Best surgeon in Vijayawada!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Kommireddy Satyanarayana", city: "Rajahmundry", rating: 5, review: "Excellent cholecystectomy by Dr. Dileep. He is very calm, explains everything, and the surgery was flawless. Recovery was quick and painless.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Bezawada Padmavathi", city: "Vijayawada", rating: 5, review: "After months of suffering from gallstones, Dr. Dileep surgery gave me complete relief. Professional team and excellent post-operative care.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Tatineni Mohana Rao", city: "Vijayawada", rating: 5, review: "Dr. Dileep performed gallbladder surgery on me. The laparoscopic approach meant less pain and I was walking the same evening. Wonderful doctor!", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Gudivada Sireesha", city: "Vijayawada", rating: 4, review: "Good experience with Dr. Dileep for my cholecystectomy. Surgery went well, recovery was smooth. Would recommend to anyone needing gallbladder surgery.", procedure: "Laparoscopic Cholecystectomy" },
  { name: "Velagapudi Rajendra Prasad", city: "Vijayawada", rating: 5, review: "Had laparoscopic appendix surgery in emergency. Dr. Dileep handled it brilliantly even at short notice. Quick surgery and I recovered in days!", procedure: "Appendicectomy" },
  { name: "Nandyala Madhavi", city: "Vijayawada", rating: 5, review: "My son had emergency appendicectomy with Dr. Dileep. We were scared but Dr. Dileep was calm and reassuring. Surgery was successful and recovery was quick.", procedure: "Appendicectomy" },
  { name: "Yelamanchili Venugopal", city: "Guntur", rating: 5, review: "Dr. Dileep performed laparoscopic appendix removal for me. Three tiny incisions, minimal pain, and I was home the next day. Excellent surgeon!", procedure: "Appendicectomy" },
  { name: "Boddupalli Srinivasarao", city: "Vijayawada", rating: 5, review: "Had appendicectomy done by Dr. Dileep. Very professional approach, explained everything before surgery. Recovery was much faster than I expected.", procedure: "Appendicectomy" },
  { name: "Kakarla Anitha", city: "Vijayawada", rating: 5, review: "Dr. Dileep fixed my hernia laparoscopically. I was back to work in 10 days with almost no visible scars. Best hernia surgeon in Vijayawada!", procedure: "Hernia" },
  { name: "Devineni Prakash", city: "Vijayawada", rating: 5, review: "I had inguinal hernia repair with Dr. Dileep. The laparoscopic approach was much better than what I expected. Minimal pain and quick recovery.", procedure: "Hernia" },
  { name: "Mangalagiri Satyanarayana", city: "Tenali", rating: 5, review: "Dr. Dileep performed bilateral hernia repair for me. Single surgery for both sides with excellent results. Truly a skilled surgeon!", procedure: "Hernia" },
  { name: "Machavaram Vijayalakshmi", city: "Vijayawada", rating: 5, review: "My father had hernia surgery with Dr. Dileep. At 70 years old, we were worried but the surgery went smoothly and he recovered well. Thank you doctor!", procedure: "Hernia" },
  { name: "Addanki Durga Prasad", city: "Vijayawada", rating: 5, review: "Had hernia mesh repair done laparoscopically. Dr. Dileep technique was excellent. No pain after day 2 and I was fully active in 2 weeks.", procedure: "Hernia" },
  { name: "Tenneti Kiran Kumar", city: "Vijayawada", rating: 5, review: "Dr. Dileep treated my piles with laser. No pain, no cuts, and I went home the same day. If you are suffering from piles, see Dr. Dileep immediately!", procedure: "General Surgery" },
  { name: "Musunuri Radhakrishna", city: "Machilipatnam", rating: 5, review: "Underwent thyroid surgery with Dr. Dileep. The scar is barely visible and the surgery was done perfectly. Very experienced and caring doctor.", procedure: "General Surgery" },
  { name: "Darsi Sumalatha", city: "Vijayawada", rating: 5, review: "Dr. Dileep removed a large lipoma from my back. Clean surgery, minimal scar, and quick healing. Excellent surgeon with gentle hands.", procedure: "General Surgery" },
  { name: "Repalle Chandrasekhar", city: "Vijayawada", rating: 5, review: "Had varicose vein treatment with Dr. Dileep. The laser treatment was quick and I was walking immediately after. Great results!", procedure: "General Surgery" },
  { name: "Narasaraopeta Meenakshi", city: "Guntur", rating: 5, review: "Dr. Dileep did my endoscopy and diagnosed my stomach problem accurately. Very thorough and professional. Now on proper treatment and feeling much better.", procedure: "General Surgery" },
  { name: "Eluru Nageswara Rao", city: "Vijayawada", rating: 5, review: "Dr. Dileep removed an abdominal cyst that had been troubling me for years. The procedure was smooth and I recovered in just a few days. Outstanding care!", procedure: "General Surgery" },
  { name: "Kuchipudi Hymavathi", city: "Guntur", rating: 5, review: "I had a fissure treated by Dr. Dileep using laser technique. Completely painless procedure and healed within a week. I wish I had come sooner!", procedure: "General Surgery" },
  { name: "Bhimavaram Tirupathi", city: "Tenali", rating: 5, review: "Dr. Dileep performed my pilonidal sinus surgery. Very neat work with minimal scarring. He explained every step clearly before and after the procedure.", procedure: "General Surgery" },
  { name: "Avanigadda Vasantha", city: "Vijayawada", rating: 5, review: "Had an infected sebaceous cyst removed by Dr. Dileep. Quick procedure under local anesthesia. Healed perfectly with no complications at all.", procedure: "General Surgery" },
  { name: "Bapatla Srinivasulu", city: "Amaravati", rating: 5, review: "Came from Amaravati for fistula treatment. Dr. Dileep used the latest laser technique. No hospital stay needed and I was back to daily routine in days.", procedure: "General Surgery" },
];

const PILLS = ["All", "Hernia", "Appendicectomy", "General Surgery", "Laparoscopic"];

const BADGE = {
  "Hernia": "bg-orange-50 text-orange-600 border-orange-200",
  "Appendicectomy": "bg-emerald-50 text-emerald-600 border-emerald-200",
  "General Surgery": "bg-violet-50 text-violet-600 border-violet-200",
  "Laparoscopic Cholecystectomy": "bg-sky-50 text-sky-600 border-sky-200",
};

const CARD_WIDTH = 300;
const GAP = 20;
const STEP = CARD_WIDTH + GAP;

export default function Testimonials() {
  const scrollRef = useRef(null);
  const animRef = useRef(null);
  const scrollPos = useRef(0);
  const isPaused = useRef(false);
  const [activeFilter, setActiveFilter] = useState("All");
  const [expanded, setExpanded] = useState({});

  const filtered = activeFilter === "All"
    ? DATA
    : DATA.filter(function(t) {
        if (activeFilter === "Laparoscopic") return t.procedure === "Laparoscopic Cholecystectomy";
        return t.procedure === activeFilter;
      });

  const displayCards = filtered.concat(filtered);

  useEffect(function() {
    scrollPos.current = 0;
    if (scrollRef.current) scrollRef.current.scrollLeft = 0;
    setExpanded({});
  }, [activeFilter]);

  useEffect(function() {
    var container = scrollRef.current;
    if (!container) return;
    function scroll() {
      if (!isPaused.current) {
        scrollPos.current += 0.5;
        var half = container.scrollWidth / 2;
        if (half > 0 && scrollPos.current >= half) scrollPos.current = 0;
        container.scrollLeft = scrollPos.current;
      }
      animRef.current = requestAnimationFrame(scroll);
    }
    animRef.current = requestAnimationFrame(scroll);
    return function() { cancelAnimationFrame(animRef.current); };
  }, [activeFilter]);

  function handlePrev() {
    isPaused.current = true;
    var container = scrollRef.current;
    if (!container) return;
    var target = scrollPos.current - STEP;
    var half = container.scrollWidth / 2;
    if (target < 0) target += half;
    scrollPos.current = target;
    container.scrollLeft = target;
    setTimeout(function() { isPaused.current = false; }, 2500);
  }

  function handleNext() {
    isPaused.current = true;
    var container = scrollRef.current;
    if (!container) return;
    var target = scrollPos.current + STEP;
    var half = container.scrollWidth / 2;
    if (target >= half) target -= half;
    scrollPos.current = target;
    container.scrollLeft = target;
    setTimeout(function() { isPaused.current = false; }, 2500);
  }

  function toggleExpand(index) {
    setExpanded(function(prev) {
      var next = {};
      for (var k in prev) next[k] = prev[k];
      next[index] = !prev[index];
      return next;
    });
  }

  return (
    <section
      id="testimonials"
      className="reveal py-16 md:py-24 bg-gradient-to-b from-slate-50 to-white overflow-hidden"
    >
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl mb-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="text-teal font-medium text-xs uppercase tracking-widest mb-2">Patient Testimonials</p>
            <h2 className="font-bold text-3xl md:text-4xl text-slate-800">What Our Patients Say</h2>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={handlePrev} className="w-11 h-11 flex items-center justify-center rounded-full border bg-white shadow hover:border-teal">
              <ChevronLeft className="w-5 h-5 text-slate-500" />
            </button>
            <button onClick={handleNext} className="w-11 h-11 flex items-center justify-center rounded-full border bg-white shadow hover:border-teal">
              <ChevronRight className="w-5 h-5 text-slate-500" />
            </button>
          </div>
        </div>

        <div className="flex gap-2 mt-6 flex-wrap">
          {PILLS.map(function(pill) {
            return (
              <button
                key={pill}
                onClick={function() { setActiveFilter(pill); }}
                className={"px-4 py-1.5 rounded-full text-xs font-semibold border transition " + (activeFilter === pill ? "bg-teal text-white border-teal" : "bg-white text-slate-500 border-slate-200 hover:border-teal hover:text-teal")}
              >
                {pill}
              </button>
            );
          })}
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex gap-5 overflow-x-hidden px-6"
        style={{ scrollBehavior: "auto" }}
      >
        {displayCards.map(function(t, i) {
          var isExpanded = expanded[i];
          var badgeClass = BADGE[t.procedure] || "bg-slate-50 text-slate-500 border-slate-200";
          var badgeLabel = t.procedure === "Laparoscopic Cholecystectomy" ? "Laparoscopic" : t.procedure;
          return (
            <div
              key={t.name + "-" + i}
              className="flex-shrink-0 w-[300px] bg-white rounded-2xl border border-slate-100 shadow-sm p-5 hover:shadow-lg transition"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex">
                  {[0,1,2,3,4].map(function(j) {
                    return <Star key={j} className={j < t.rating ? "w-4 h-4 text-amber-400 fill-amber-400" : "w-4 h-4 text-slate-200"} />;
                  })}
                </div>
                <span className={"text-[10px] font-semibold px-2 py-0.5 rounded-full border " + badgeClass}>
                  {badgeLabel}
                </span>
              </div>
              <p className={"text-sm text-slate-600 leading-relaxed " + (isExpanded ? "" : "line-clamp-4")}>
                {t.review}
              </p>
              {t.review.length > 120 && (
                <button
                  onClick={function() { toggleExpand(i); }}
                  className="text-teal text-xs font-semibold mt-1"
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              )}
              <div className="border-t mt-4 pt-3 flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-teal/20 flex items-center justify-center text-teal font-bold text-sm flex-shrink-0">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-slate-800 text-sm">{t.name}</p>
                  <p className="text-xs text-slate-400">{t.city}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}